import React from 'react'
import { hydrate, render } from 'react-dom'
import { Provider } from 'react-redux'

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils'
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'

import 'helpers/console/init-dev-console'
import registerServiceWorker from './registerServiceWorker'

import { theme } from 'config/theme'
import store from 'store'
import App from './App'

import 'assets/css/styles.css?v=1.3.0'

const rootEl = document.getElementById('root')

const AppRoot = () => (
  <div>
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <App />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </Provider>
  </div>
)

if (rootEl.hasChildNodes()) {
  hydrate(<AppRoot />, rootEl)
} else {
  render(<AppRoot />, rootEl)
}

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js